// removed by extract-text-webpack-plugin
module.exports = {"columnHeader":"SortHeader__columnHeader--1_y2l","activeHeader":"SortHeader__activeHeader--2q3QR","columnHeaderText":"SortHeader__columnHeaderText--1RQpB","dropdownIconStyle":"SortHeader__dropdownIconStyle--PKh_T","statPopup":"SortHeader__statPopup--2fSJm"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/DataTable/SortHeader/SortHeader.css
// module id = A2QQ
// module chunks = 47